export default __webpack_public_path__ + "static/media/investment_card_3@3x.2eac3049.png";